import Axios from "axios";
import CONFIG from "../../../model/TSConfig";

export const getTimestampsForFirstAndLastPayer = async (
  owner: string,
  token: string
): Promise<{ sts: number; ets: number }> => {
  const res = await Axios({
    url: `${CONFIG.saasBackendUrl}/customer-dashboard/monthly-interval`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: {
      owner
    }
  });

  return res.data;
};
